var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boolean_icon"},[(_vm.isTrue)?_c('i',{staticClass:"right_icon zmdi zmdi-check"}):_c('i',{staticClass:"bad_icon zmdi zmdi-close"})])}
var staticRenderFns = []

export { render, staticRenderFns }